const $body = document.querySelector('body');
const $modalBackground = document.getElementById('modalOuter');
let scrollPosition = 0;

export default {
    enable() {
        scrollPosition = window.pageYOffset;
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${scrollPosition}px`;
        $body.style.width = '100%';
        $modalBackground.style.position = 'absolute';
        $modalBackground.style.top = `-${scrollPosition}px`;
        $modalBackground.style.bottom = 0;
        $modalBackground.style.right = 0;
        $modalBackground.style.left = 0;
        $modalBackground.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        $modalBackground.style.zIndex = '501';
        $modalBackground.style.overflow = 'hidden';
    },
    disable() {
        scrollPosition = -parseInt($body.style.top);
        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        $modalBackground.style.removeProperty('overflow');
        $modalBackground.style.removeProperty('position');
        $modalBackground.style.removeProperty('top');
        $modalBackground.style.removeProperty('bottom');
        $modalBackground.style.removeProperty('right');
        $modalBackground.style.removeProperty('left');
        $modalBackground.style.removeProperty('backgroundColor');
        $modalBackground.style.removeProperty('zIndex');
        window.scrollTo(0, scrollPosition)
    }
};
